export const FETCH_FOOTER_REQUESTED =
  'footer/FETCH_FOOTER_REQUESTED'
export const FETCH_FOOTER_SUCCEEDED =
  'competitions/FETCH_FOOTER_SUCCEEDED'
export const FETCH_FOOTER_FAILED =
  'competitions/FETCH_FOOTER_FAILED'



// WEBPACK FOOTER //
// ./src/store/footer/actionTypes.js